import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";

// Giriş yapmış üyeye, henüz yanıtlamadığı yayındaki belge sürümlerini sırayla gösterir (adım 10).
// Sunucu yalnızca bildirim şekli "bilgilendirme" ya da "onay" olan sürümleri döndürür (yalnızca e-posta olanlar gelmez):
//   bilgilendirme → "Anladım" (goruldu)
//   onay          → "Onaylıyorum" (onayladi) / "Şimdilik değil" (kabul_etmedi); kullanım hiçbir durumda engellenmez
// × → bu oturumda ertelenir. Üyelik sözleşmesi onayı yenilemede alınır.
// Uygulamadaki BelgeOnayServisi.dart ile aynı düzen. Uçlar: /api/belgeler/bekleyenler, /api/belgeler/yanitla

// Belgenin kendisinin, ödemenin ve girişin okunduğu sayfalarda popup çıkmaz
const GIZLI_YOLLAR = [
  "/gizlilik_politikasi",
  "/iletisim_formu_aydinlatma_metni",
  "/yenile",
  "/posnet-payment",
  "/posnet-odeme-sonuc",
  "/payment",
  "/login",
  "/register",
  "/forgot",
];
const SAYFA_ADRESI = {
  uyelik_sozlesmesi: "/gizlilik_politikasi/uyelik_satis_sozlesmesi",
  gizlilik: "/gizlilik_politikasi",
};
const ERTELENEN_ANAHTARI = "belgeOnayErtelenen";

const API = process.env.REACT_APP_API_URL;

async function apiPost(yol, govde) {
  try {
    const cevap = await fetch(`${API}${yol}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(govde),
    });
    return await cevap.json();
  } catch (error) {
    return { m: "baglanti_hatasi" };
  }
}

function ertelenenleriOku() {
  try {
    return JSON.parse(sessionStorage.getItem(ERTELENEN_ANAHTARI) || "[]");
  } catch (_) {
    return [];
  }
}

function ertelenenEkle(id) {
  try {
    sessionStorage.setItem(ERTELENEN_ANAHTARI, JSON.stringify([...ertelenenleriOku(), id]));
  } catch (_) {}
}

const Ikon = ({ ad, renk }) => {
  const ortak = { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: renk, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true };
  if (ad === "kalkan")
    return (
      <svg {...ortak}>
        <path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6l8-3z" />
      </svg>
    );
  return (
    <svg {...ortak}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" />
      <path d="M14 3v5h5M9 13h6M9 17h6" />
    </svg>
  );
};

export default function BelgeOnayPopup() {
  const location = useLocation();
  const token = Cookies.get("token");
  const gizliSayfa = GIZLI_YOLLAR.some((yol) => location.pathname.startsWith(yol));

  const [yuklenenToken, setYuklenenToken] = useState(null);
  const [kuyruk, setKuyruk] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [metinAcik, setMetinAcik] = useState(false);
  const [islemde, setIslemde] = useState(false);
  const [hata, setHata] = useState(null);

  // Token değiştiğinde (giriş/çıkış) bekleyenleri bir kez çek; gizli sayfada bekle
  useEffect(() => {
    if (!token) {
      setKuyruk([]);
      setYuklenenToken(null);
      return;
    }
    if (gizliSayfa || yuklenenToken === token) return;
    setYuklenenToken(token);
    (async () => {
      const r = await apiPost("/api/belgeler/bekleyenler", { token });
      if (r.m !== "basarili") return;
      const ertelenen = ertelenenleriOku();
      const liste = r.belgeler.filter((b) => !ertelenen.includes(b.id));
      setKuyruk(liste);
      setToplam(liste.length);
    })();
  }, [token, gizliSayfa, yuklenenToken]);

  const belge = kuyruk[0];
  if (!token || gizliSayfa || !belge) return null;

  const siradaki = () => {
    setKuyruk((k) => k.slice(1));
    setMetinAcik(false);
    setHata(null);
  };

  const yanitla = async (durum) => {
    setIslemde(true);
    setHata(null);
    const r = await apiPost("/api/belgeler/yanitla", { token, surumId: belge.id, durum, kanal: "web" });
    setIslemde(false);
    // Belge bu arada güncellendiyse kuyruk yeniden çekilir (üye görmediği sürümü onaylamasın)
    if (r.m === "belge_guncel_degil") {
      setKuyruk([]);
      setYuklenenToken(null);
      return;
    }
    if (r.m !== "basarili") {
      setHata(r.mesaj || "Yanıtınız kaydedilemedi. Lütfen tekrar deneyin.");
      return;
    }
    siradaki();
  };

  const ertele = () => {
    ertelenenEkle(belge.id);
    siradaki();
  };

  const baslikMetni =
    belge.tur === "gizlilik"
      ? "Gizlilik politikamızı güncelledik"
      : belge.tur === "platform_kurallari"
      ? "Platform kurallarımızı güncelledik"
      : "Üyelik sözleşmemizi güncelledik";
  const sira = toplam - kuyruk.length + 1;
  const sayfa = SAYFA_ADRESI[belge.tur];

  return (
    <div style={stil.zemin} role="dialog" aria-modal="true" aria-labelledby="belge-onay-baslik">
      <div style={stil.kart}>
        <div style={stil.ust}>
          <div style={stil.ikonDaire}>
            <Ikon ad={belge.tur === "gizlilik" ? "kalkan" : "belge"} renk={renk.mor} />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            {toplam > 1 && (
              <span style={stil.ilerleme}>
                {sira} / {toplam}
              </span>
            )}
            <button type="button" onClick={ertele} style={stil.kapat} aria-label="Kapat">
              ×
            </button>
          </div>
        </div>

        <h2 id="belge-onay-baslik" style={stil.baslik}>
          {baslikMetni}
        </h2>
        <div style={stil.altBaslik}>
          {belge.baslik} · Sürüm {belge.surum} · {belge.yururlukMetin} tarihinden itibaren
        </div>

        {belge.metin ? (
          <>
            <button type="button" onClick={() => setMetinAcik((a) => !a)} style={stil.metinSatiri} aria-expanded={metinAcik}>
              <span style={stil.metinSatiriYazi}>{metinAcik ? "Tam metni gizle" : "Tam metni oku"}</span>
              <span style={{ ...stil.ok, transform: metinAcik ? "rotate(90deg)" : "none" }} aria-hidden="true">
                ›
              </span>
            </button>
            {metinAcik && <div style={stil.tamMetin}>{belge.metin}</div>}
          </>
        ) : (
          sayfa && (
            <a href={sayfa} target="_blank" rel="noopener noreferrer" style={stil.metinSatiri}>
              <span style={stil.metinSatiriYazi}>Tam metni oku</span>
              <span style={stil.ok} aria-hidden="true">
                ›
              </span>
            </a>
          )
        )}

        {hata && <div style={stil.hata}>{hata}</div>}

        <div style={stil.butonlar}>
          {belge.bildirimSekli === "onay" ? (
            <>
              <button type="button" disabled={islemde} onClick={() => yanitla("onayladi")} style={stil.birincil(islemde)}>
                {islemde ? "Kaydediliyor…" : "Onaylıyorum"}
              </button>
              <button type="button" disabled={islemde} onClick={() => yanitla("kabul_etmedi")} style={stil.ikincil}>
                Şimdilik değil
              </button>
            </>
          ) : (
            <button type="button" disabled={islemde} onClick={() => yanitla("goruldu")} style={stil.birincil(islemde)}>
              {islemde ? "Kaydediliyor…" : "Anladım"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const renk = {
  mor: "#6366f1",
  morAcik: "#eef2ff",
  metin: "#1e293b",
  soluk: "#64748b",
  cizgi: "#e2e8f0",
  zemin: "#f8fafc",
};

const stil = {
  // Çerez uyarısının (z-index 99999) üstünde: kısa ekranlarda uyarı popup düğmelerini örtmesin
  zemin: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.6)",
    zIndex: 100000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
  },
  kart: {
    background: "#fff",
    borderRadius: "24px",
    width: "100%",
    maxWidth: "460px",
    maxHeight: "90vh",
    overflowY: "auto",
    padding: "24px 24px 16px",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.3)",
    color: renk.metin,
    textAlign: "left",
  },
  ust: { display: "flex", justifyContent: "space-between", alignItems: "center" },
  ikonDaire: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    background: renk.morAcik,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  ilerleme: { background: renk.zemin, color: renk.soluk, fontSize: "12px", fontWeight: 600, borderRadius: "20px", padding: "4px 10px" },
  kapat: { background: "none", border: "none", fontSize: "28px", lineHeight: 1, color: renk.soluk, cursor: "pointer", padding: "0 6px" },
  baslik: { fontSize: "20px", fontWeight: 700, margin: "16px 0 4px", lineHeight: 1.3, color: renk.metin },
  altBaslik: { fontSize: "13px", color: renk.soluk, lineHeight: 1.4 },
  metinSatiri: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginTop: "18px",
    background: renk.zemin,
    border: "none",
    borderRadius: "14px",
    padding: "14px",
    cursor: "pointer",
    textDecoration: "none",
    color: renk.metin,
    font: "inherit",
  },
  metinSatiriYazi: { flex: 1, textAlign: "left", fontSize: "14px", fontWeight: 600 },
  ok: { fontSize: "22px", lineHeight: 1, color: renk.soluk, transition: "transform 0.15s" },
  tamMetin: {
    whiteSpace: "pre-wrap",
    maxHeight: "40vh",
    overflowY: "auto",
    border: `1px solid ${renk.cizgi}`,
    borderRadius: "14px",
    padding: "14px",
    marginTop: "8px",
    fontSize: "14px",
    lineHeight: 1.6,
  },
  hata: { color: "#b91c1c", fontSize: "14px", marginTop: "12px" },
  butonlar: { display: "flex", flexDirection: "column", gap: "4px", marginTop: "20px" },
  birincil: (pasif) => ({
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    opacity: pasif ? 0.6 : 1,
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "14px 18px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: pasif ? "default" : "pointer",
  }),
  ikincil: {
    background: "none",
    color: renk.soluk,
    border: "none",
    borderRadius: "14px",
    padding: "12px 18px",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
  },
};
